/* Etichette e filtro della pagina Campagne. Modulo PURO: niente React, niente axios,
   cosi' la parte che si sbaglia piu' facilmente (il filtro) si prova a tavolino. */

export const STATI = [
  { key: 'da_indagare', label: 'Da indagare' },
  { key: 'in_corso', label: 'In corso' },
  { key: 'risolta', label: 'Risolta' },
  { key: 'non_risolta', label: 'Non risolta' },
  { key: 'scartata', label: 'Scartata' },
];

const LBL_STATO = Object.fromEntries(STATI.map((s) => [s.key, s.label]));

/* Gli stati su cui l'indagine si puo' accendere o spegnere: e' l'elenco che il backend
   usa in restringi_stati() per /righe/attiva. Sta qui accanto a STATI perche' serve sia
   all'interruttore di riga sia (Task 7) alle azioni di massa, e una seconda copia in un
   componente vorrebbe dire due idee diverse di cosa e' accendibile. */
export const STATI_ATTIVABILI = ['da_indagare', 'non_risolta'];

// Il codice non lo legge nessuno: quello che conta e' che si capisca cosa e' successo.
const LBL_MOTIVO = {
  cellulare: 'cellulare: il 456 verifica solo i fissi',
  persona_fisica: 'persona fisica: niente partita IVA',
  azienda_in_archivio: "l'azienda è già in archivio",
  numero_in_archivio: "il numero è già in archivio",
  nessun_sito: 'trovata su Maps, ma senza sito da controllare',
  nessun_numero: 'nessun numero trovato',
  nessun_match: 'i numeri trovati non combaciano con le cifre visibili',
  candidati_ambigui: 'più numeri combaciano: impossibile scegliere',
  azienda_non_trovata: 'azienda non trovata su Maps',
  azienda_diversa: "su Maps compare un'altra azienda",
  identita_non_verificabile: "numero trovato, ma non si è potuta verificare l'azienda",
  archiviazione_fallita: 'numero buono, scrittura in archivio non riuscita',
  gia_lavorata: 'già lavorata in una lista precedente',
  tempo_scaduto: 'l’indagine ha sforato il tempo massimo: si può ri-indagare',
  // Liste CERVED: la prova non sono le cifre visibili ma la partita IVA letta sul sito.
  piva_non_confermata: 'partita IVA non trovata sul sito',
  piva_diversa: 'sul sito c’è un’altra partita IVA',
  numeri_ambigui: 'più numeri fissi, scegli tu',
  solo_cellulari: 'trovati solo cellulari',
  // Liste da import: il nome non combaciava, ma il cellulare che il file aveva e' scritto
  // online. E' una riga RISOLTA: il motivo resta per dire che la prova non era il nome.
  cellulare_combacia: 'riconosciuta dal cellulare della lista',
};

/* I motivi, nell'ordine in cui sono scritti qui sopra: serve alla tendina dei filtri.
   Sta qui e non nel componente perche' l'elenco delle chiavi e le loro etichette devono
   restare una cosa sola — aggiungerne uno solo di la' vorrebbe dire un filtro senza testo. */
export const MOTIVI = Object.keys(LBL_MOTIVO);

/* I motivi che nascono solo sulle liste CERVED: la tendina li mostra solo quando se ne
   guardano, cosi' chi lavora solo liste TIM la ritrova com'era. */
export const MOTIVI_CERVED = ['piva_non_confermata', 'piva_diversa', 'numeri_ambigui', 'solo_cellulari'];

const COL_STATO = {
  da_indagare: 'var(--muted)',
  in_corso: 'var(--info)',
  risolta: 'var(--ok)',
  non_risolta: 'var(--warn)',
  scartata: 'var(--muted)',
};

/* La spiegazione per esteso di ogni stato: la pastiglia ha poco posto, e "Scartata" da
   sola non dice se la riga e' stata guardata o messa da parte prima ancora di guardarla.
   Finisce nel `title` di ogni pastiglia e di ogni contatore. */
const SPIEGA_STATO = {
  da_indagare: 'In attesa: l’indagine non è ancora passata di qui.',
  in_corso: 'Il motore la sta guardando adesso.',
  risolta: 'Numero ricostruito: è nato il record in archivio.',
  non_risolta: 'Indagata, ma il numero non si è potuto ricostruire. Il bottino '
             + 'dell’indagine resta sulla riga.',
  scartata: 'Messa da parte: o non meritava un’indagine (cellulare, persona fisica), '
          + 'o quell’azienda era già in archivio, o era già passata da una lista precedente.',
};

export const etichettaStato = (stato) => LBL_STATO[stato] || stato || '';
export const spiegazioneStato = (stato) => SPIEGA_STATO[stato] || '';

/** Il testo del `title` di una pastiglia: cosa vuol dire lo stato e, se c'e', perche'. */
export function titoloStato(stato, motivo) {
  return [spiegazioneStato(stato), etichettaMotivo(motivo)].filter(Boolean).join(' — ');
}
export const etichettaMotivo = (motivo) => LBL_MOTIVO[motivo] || motivo || '';
export const coloreStato = (stato) => COL_STATO[stato] || 'var(--muted)';

/** Il grado di identita' si mostra SOLO quando e' piu' debole del normale: decorare il
    caso buono sarebbe rumore. */
export function etichettaIdentita(identita) {
  if (identita === 'comune') {
    return { label: 'identità dal comune',
             titolo: "Il nome sulla scheda di Maps non si è potuto leggere: "
                   + "l'azienda è stata riconosciuta dal comune dell'indirizzo." };
  }
  if (identita === 'nessuna') {
    return { label: 'identità non verificata',
             titolo: 'Non si è potuto verificare né il nome né il comune: '
                   + 'il numero trovato non entra in archivio da solo.' };
  }
  return null;
}

/* Quante lettere prima di cercare nella ragione sociale. La ricerca e' una $regex che
   nessun indice puo' aiutare, e ogni cambio di filtro costa DUE conteggi completi sulle
   righe: con una lettera sola si scandiscono decine di migliaia di righe per un risultato
   che non serve a nessuno. Sotto la soglia il filtro semplicemente non parte. */
export const Q_MINIMO = 3;

/* I tre tipi di lista, ognuno con la sua prova. 'tim' ha il numero troncato e la prova sono
   le cifre visibili; 'cerved' non ha il numero ma ha la partita IVA certa, e la prova e'
   quella letta sul sito; 'generica' arriva dall'importazione normale — un nome, un comune e
   al massimo un cellulare — ed e' la lista sporca che prima si sarebbe buttata.
   Una campagna (o una riga) senza campo e' di prima dei CERVED: vale 'tim'. */
export const TIPI_LISTA = ['tim', 'cerved', 'generica'];
export const tipoLista = (x) => {
  const t = (x || {}).tipo;
  return t === 'cerved' || t === 'generica' ? t : 'tim';
};
export const eCerved = (x) => tipoLista(x) === 'cerved';
export const eGenerica = (x) => tipoLista(x) === 'generica';

/* Il numero che la lista generica aveva: un cellulare, o un numero troncato. Non e' il
   numero da verificare — il 456 i cellulari non li lavora — ma e' l'unico recapito che si
   ha per riconoscere l'azienda, e chi guarda la riga deve poterlo vedere. */
export const numeroDaLista = (riga) => {
  const r = riga || {};
  if (!eGenerica(r)) return '';
  return (r.cellulari_lista || [])[0] || (r.mascherati_lista || [])[0] || '';
};

/** Dal modulo dei filtri al corpo da mandare al backend. Le chiavi vuote non partono:
    una stringa vuota mandata come filtro cercherebbe il vuoto invece di non filtrare. */
export function costruisciFiltro(form) {
  const f = form || {};
  const out = {};
  ['campagna_id', 'stato', 'motivo', 'provincia', 'tipo_impresa', 'tipo_linea'].forEach((k) => {
    if (f[k]) out[k] = f[k];
  });
  if (TIPI_LISTA.includes(f.tipo)) out.tipo = f.tipo;
  if (typeof f.attiva === 'boolean') out.attiva = f.attiva;
  if (f.ha_piva === true) out.ha_piva = true;
  if (f.ha_email === true) out.ha_email = true;
  if (f.ex_tim === true) out.ex_tim = true;
  if (f.ftth_nuova === true) out.ftth_nuova = true;
  const q = (f.q || '').trim();
  if (q.length >= Q_MINIMO) out.q = q;
  return out;
}

/** "12 risolte · 40 da indagare · 5 non risolte" — gli zeri non si scrivono. */
export function riassuntoCampagna(contatori) {
  const c = contatori || {};
  return [
    c.risolta ? `${c.risolta} risolte` : null,
    c.da_indagare ? `${c.da_indagare} da indagare` : null,
    c.in_corso ? `${c.in_corso} in corso` : null,
    c.non_risolta ? `${c.non_risolta} non risolte` : null,
    c.scartata ? `${c.scartata} scartate` : null,
  ].filter(Boolean).join(' · ');
}

/* Le cifre che il motore confronta DAVVERO. `campagne_csv.maschera()` toglie dal grezzo
   il '39' internazionale scritto senza '+': mostrando `linea_contatto` si leggerebbe
   '390984251***' mentre il motore usa '0984251', e chi guarda le cifre visibili per
   capire perche' una riga non si e' risolta vedrebbe un numero diverso da quello vero.
   Il grezzo del file resta nel tooltip. Sta qui, e non nella pagina, perche' la tabella
   e il dettaglio devono mostrare lo STESSO numero. */
export const numeroMascherato = (riga) => {
  const r = riga || {};
  return r.mask_visibile
    ? r.mask_visibile + '*'.repeat(r.mask_nascoste || 0)
    : (r.linea_contatto || '');
};

/* I motivi che ammettono la promozione a mano: e' la copia esatta di
   `campagne_engine._MOTIVI_PROMUOVIBILI`. Gli altri no, e per ragioni diverse:
   'nessun_match' e 'candidati_ambigui' dicono che il numero NON e' quello della campagna,
   'piva_diversa' che il sito e' di un'altra azienda, 'solo_cellulari' che un fisso non c'e':
   scriverli in archivio sarebbe il danno che tutto il sottosistema esiste per evitare.
   Dei CERVED: 'piva_non_confermata' si promuove col numero trovato (la partita IVA sul
   sito non c'era, la decisione e' di chi guarda), 'numeri_ambigui' scegliendo uno dei fissi. */
export const MOTIVI_PROMUOVIBILI = ['identita_non_verificabile', 'archiviazione_fallita',
  'piva_non_confermata', 'numeri_ambigui'];

/** I fissi fra cui scegliere, per una riga 'numeri_ambigui': senza doppioni e senza vuoti. */
export function fissiDaScegliere(riga) {
  const r = riga || {};
  return [...new Set((r.fissi || []).filter(Boolean))];
}

/** True se per promuovere la riga bisogna scegliere il numero (e mandarlo al backend). */
export const serveSceltaNumero = (riga) => (riga || {}).motivo === 'numeri_ambigui';

/** True se la riga tiene un numero buono che pero' non e' finito in archivio, e quindi
    una persona puo' decidere di metterlo lei. Stessa regola di `campagne_engine.promuovibile`:
    il backend rifiuterebbe comunque, ma un pulsante che non si puo' premere non si mostra.
    Per 'numeri_ambigui' il numero non c'e' ancora: serve almeno un fisso da scegliere. */
export function promuovibileRiga(riga) {
  const r = riga || {};
  if (r.stato !== 'non_risolta' || !MOTIVI_PROMUOVIBILI.includes(r.motivo)) return false;
  return serveSceltaNumero(r) ? fissiDaScegliere(r).length > 0 : !!r.numero_trovato;
}

/* ── Liste CERVED: la partita IVA letta sul sito e i dati commerciali ── */

const soloCifre = (v) => String(v ?? '').replace(/\D/g, '');

/** L'esito del confronto fra la partita IVA della lista e quella letta sul sito:
    'combacia' | 'diversa' | 'non_trovata', oppure null quando non c'e' niente da dire
    (riga non CERVED, o nessun sito aperto: "non trovata" su un sito mai letto sarebbe falso). */
export function confrontoPiva(riga) {
  const r = riga || {};
  if (!eCerved(r)) return null;
  const sito = soloCifre(r.piva_sito);
  if (sito) {
    const lista = soloCifre(r.partita_iva);
    return lista && sito.padStart(11, '0') === lista.padStart(11, '0') ? 'combacia' : 'diversa';
  }
  if (r.motivo === 'piva_non_confermata' || (r.indagata_at && r.sito)) return 'non_trovata';
  return null;
}

/** '30GG' / '90GG' detti in italiano; null se la fibra non e' in arrivo. */
export function fibraInArrivo(cerved) {
  const v = String((cerved || {}).ftth_nuova || '').trim().toUpperCase();
  const m = v.match(/^(\d+)\s*GG$/);
  return m ? `entro ${m[1]} giorni` : null;
}

const vuoto = (v) => v === null || v === undefined || (typeof v === 'string' && !v.trim());
const fmtNum = (n) => Number(n).toLocaleString('it-IT', { maximumFractionDigits: 2 });

/** "ATTIVO_FC_AREA_GRIGIA" -> "Attivo FC area grigia": le sigle corte restano maiuscole. */
export function leggibile(v) {
  if (vuoto(v)) return '';
  const s = String(v).trim();
  if (!s.includes('_') && s !== s.toUpperCase()) return s;
  const MAP = { SI: 'sì', NO: 'no' };
  const parole = s.split(/[_\s]+/).filter(Boolean).map((p) => {
    if (MAP[p.toUpperCase()]) return MAP[p.toUpperCase()];
    return /^[A-Z0-9]{1,2}$/.test(p) || /\d/.test(p) ? p : p.toLowerCase();
  });
  const t = parole.join(' ');
  return t.charAt(0).toUpperCase() + t.slice(1);
}

/** Si / no per i campi a due valori, qualunque sia la forma in cui arrivano. */
const siNo = (v) => {
  if (v === true) return 'sì';
  if (v === false) return 'no';
  const s = String(v ?? '').trim().toUpperCase();
  if (['SI', 'SÌ', 'S', '1', 'TRUE', 'Y', 'YES'].includes(s)) return 'sì';
  if (['NO', 'N', '0', 'FALSE'].includes(s)) return 'no';
  return leggibile(v);
};

/** Un numero da un valore CERVED, che puo' arrivare come numero o come stringa all'italiana
    ("315,00", "1.997.000", "2"); null se non e' un numero. */
export function aNumero(v) {
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  if (vuoto(v)) return null;
  const s = String(v).trim().replace(/\s/g, '');
  const n = Number(s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s.replace(/\.(?=\d{3}(\D|$))/g, ''));
  return Number.isFinite(n) ? n : null;
}

/** True per le classi "non disponibile" di CERVED: iniziano con Z (`Z *ND`, `Z: ND`, `Z_NO`). */
export const classeNonDisponibile = (classe) => /^Z(\W|_|$)/i.test(String(classe ?? '').trim());

/** "G: CRESCITA FRA 10% E 50%" -> "crescita fra 10% e 50%", "A: ALTO" -> "alto",
    "D: 500K-1M" -> "500K-1M". La lettera d'ordine si toglie; le parole vanno in minuscolo, le
    sigle con le cifre ("500K-1M") restano come sono. '' se vuota o non disponibile (Z…). */
export function classeLeggibile(classe) {
  if (vuoto(classe) || classeNonDisponibile(classe)) return '';
  const s = String(classe).trim().replace(/^[A-Y]\s*[:_]\s*/i, '').trim();
  return /[A-Za-zÀ-ÿ]{3,}/.test(s) ? s.toLowerCase() : s;
}

/** Il fatturato in euro, leggibile: "1,25 mln €" dal milione in su, "850.000 €" sotto. */
export function fmtEuro(v) {
  const n = aNumero(v);
  if (n === null) return '';
  if (Math.abs(n) >= 1e6) {
    return `${(n / 1e6).toLocaleString('it-IT', { maximumFractionDigits: 2 })} mln €`;
  }
  return `${n.toLocaleString('it-IT', { maximumFractionDigits: 0, useGrouping: true })} €`;
}

/** "7 (6-9)": il numero e, accanto, la classe leggibile (se c'e' ed e' disponibile). */
const conClasse = (valore, classe) => {
  const c = classeLeggibile(classe);
  if (!valore) return c;
  return c ? `${valore} (${c})` : valore;
};

const EX_TIM = { FISSO: 'sì, sul fisso', MOBILE: 'sì, sul mobile' };

/** L'ex cliente TIM detto per esteso (con gli anni se ci sono), oppure '' se non si sa. */
export function exClienteTim(cerved) {
  const c = cerved || {};
  if (vuoto(c.ex_tim)) return '';
  const v = String(c.ex_tim).trim().toUpperCase();
  if (v === 'NO') return 'no';
  const base = EX_TIM[v] || `sì (${String(c.ex_tim).trim().toLowerCase()})`;
  const n = aNumero(c.anni_ex_tim);
  if (n === null) return base;
  return `${base} · da ${fmtNum(n)} ${n === 1 ? 'anno' : 'anni'}`;
}

/** True se l'azienda e' stata cliente TIM (qualunque linea). */
export const eraClienteTim = (cerved) => {
  const v = String((cerved || {}).ex_tim || '').trim().toUpperCase();
  return !!v && v !== 'NO';
};

/** I dati CERVED in gruppi ordinati, pronti per il dettaglio:
    [{titolo, voci:[{k, v, forte?, titolo?}]}]. I valori vuoti non ci sono, e un gruppo senza
    voci non c'e'. Le coordinate stanno a parte (`coordinateCerved`), perche' diventano un
    collegamento.

    Le unita', misurate sul file vero: `fatturato` e' in euro; `var_fatturato` non ha
    un'unita' ricostruibile (arriva a -8.009 e a 90.500), quindi se ne mostra SOLO la classe;
    dei potenziali l'unita' non si sa, quindi si mostra la classe e il numero grezzo sta solo
    nel tooltip (`titolo`). */
export function gruppiCerved(cerved) {
  const c = cerved || {};
  const voce = (k, v, forte, titolo) => (vuoto(v) ? null
    : { k, v: String(v), ...(forte ? { forte: true } : {}), ...(titolo ? { titolo } : {}) });
  const arrivo = fibraInArrivo(c);
  const potenziale = (k, numero, classe) => {
    const n = aNumero(numero);
    return voce(k, classeLeggibile(classe), false,
      n === null ? '' : `Valore grezzo CERVED: ${fmtNum(n)}`);
  };
  const intero = (v) => { const n = aNumero(v); return n === null ? '' : fmtNum(n); };
  const varFatt = vuoto(c.classe_var_fatturato) ? ''
    : classeNonDisponibile(c.classe_var_fatturato) ? 'dato non disponibile'
      : classeLeggibile(c.classe_var_fatturato);
  const gruppi = [
    { titolo: 'Copertura', voci: [
      arrivo ? voce('Fibra in arrivo', arrivo, true) : null,
      voce('FTTC', leggibile(c.copertura_fttc)),
      voce('FTTH', leggibile(c.copertura_ftth)),
      voce('10 Giga', leggibile(c.copertura_10giga)),
      voce('FWA 4G', leggibile(c.copertura_fwa_4g)),
      voce('FWA 5G', leggibile(c.copertura_fwa_5g)),
      voce('Attivazione facile', vuoto(c.attivazione_facile) ? '' : siNo(c.attivazione_facile)),
    ] },
    { titolo: 'Rapporto con TIM', voci: [
      voce('Ex cliente TIM', exClienteTim(c), eraClienteTim(c)),
    ] },
    { titolo: 'Potenziale', voci: [
      potenziale('Potenziale fisso', c.potenziale_fix, c.classe_pot_fix),
      potenziale('Potenziale mobile', c.potenziale_mob, c.classe_pot_mob),
      potenziale('Potenziale IT', c.potenziale_it, c.classe_pot_it),
      voce('Propensione IT', classeLeggibile(c.propensione_it)),
    ] },
    { titolo: 'Azienda', voci: [
      voce('Settore ATECO', [
        [c.ateco_codice, c.ateco_desc].filter((x) => !vuoto(x)).map((x) => String(x).trim()).join(' — '),
        vuoto(c.sezione_ateco) ? '' : `(sezione ${String(c.sezione_ateco).trim()})`,
      ].filter(Boolean).join(' ')),
      voce('Forma giuridica', vuoto(c.forma_giuridica) ? '' : String(c.forma_giuridica).trim()),
      voce('Addetti', conClasse(intero(c.addetti), c.classe_addetti)),
      voce('Fatturato', conClasse(fmtEuro(c.fatturato), c.classe_fatturato)),
      voce('Variazione fatturato', varFatt),
      voce('Nuova impresa', vuoto(c.nuova_impresa) ? '' : siNo(c.nuova_impresa)),
      voce('Sedi', intero(c.n_sedi)),
      voce('Gruppo', vuoto(c.gruppo) ? '' : String(c.gruppo).trim()),
      voce('Pagine Bianche', vuoto(c.pagine_bianche) ? '' : siNo(c.pagine_bianche)),
    ] },
  ];
  return gruppi
    .map((g) => ({ ...g, voci: g.voci.filter(Boolean) }))
    .filter((g) => g.voci.length > 0);
}

/** Le coordinate pronte da mostrare, col collegamento a Google Maps; null se mancano. */
export function coordinateCerved(cerved) {
  const c = cerved || {};
  const lat = Number(c.lat);
  const lon = Number(c.lon);
  if (vuoto(c.lat) || vuoto(c.lon) || !Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (lat === 0 && lon === 0) return null;
  return {
    testo: `${lat.toFixed(5)}, ${lon.toFixed(5)}`,
    url: `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`,
  };
}

/* I motivi di scarto che sono una SCELTA e non un fatto, e quindi si riarmano a mano: copia
   esatta di `campagne_store.MOTIVI_RIARMABILI`. 'persona_fisica' (interessano le aziende) e
   'gia_lavorata' (un'azienda gia' passata da una lista precedente, che si puo' voler
   ri-indagare). Fuori restano 'cellulare' (il 456 non lo verifichera' mai) e
   'azienda_in_archivio' / 'numero_in_archivio' (quel cliente in archivio c'e' gia'). */
export const MOTIVI_RIARMABILI = ['persona_fisica', 'gia_lavorata'];

/** True se la riga e' scartata per un motivo riarmabile: stessa regola di /righe/riarma. */
export function riarmabileRiga(riga) {
  const r = riga || {};
  return r.stato === 'scartata' && MOTIVI_RIARMABILI.includes(r.motivo);
}

/** "i motivi riarmabili" detti in italiano, per i testi di pulsanti e avvisi. */
export const RIARMABILI_TESTO = 'scartate come persona fisica o come già lavorate '
  + 'in una lista precedente';

const soloData = (at) => {
  if (!at) return '';
  const d = new Date(at);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('it-IT',
    { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/** Il riferimento `gia_vista_in` di una riga, pronto da mostrare, oppure null.

    `storia` e' vero quando la riga NON e' piu' scartata come 'gia_lavorata' (e' stata
    riarmata, o indagata dopo): il riferimento resta sulla riga come storia e non va letto
    come un segnale di scarto — conta sempre lo stato attuale. L'esito di allora passa dal
    motivo, e se il motivo manca dall'etichetta dello stato. */
export function giaVista(riga) {
  const g = (riga || {}).gia_vista_in;
  if (!g || typeof g !== 'object') return null;
  return {
    campagna: g.campagna_nome || '',
    campagnaId: g.campagna_id || '',
    rigaId: g.riga_id || '',
    data: soloData(g.data),
    esito: g.motivo ? etichettaMotivo(g.motivo) : etichettaStato(g.stato),
    storia: !(riga.stato === 'scartata' && riga.motivo === 'gia_lavorata'),
  };
}
